import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bind-activity-item-tags-widget" }
const _hoisted_2 = { class: "bind-activity-item-tags-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bind-activity-item-tags-dialog__label" }, "营销商品标签", -1)
const _hoisted_4 = { class: "bind-activity-item-tags-footer" }
const _hoisted_5 = { class: "bind-activity-item-tags-footer__actions" }

import { computed, ref } from 'vue';
import { OioButton, OioModal, OioSpin } from '@kunlun/vue-ui-antd';

interface CmTagRecord {
  id: string;
  name: string;
}

interface ActivityItemTagRelRecord {
  tagId?: number | string;
  tagName?: string;
}

interface ActivityItemRecord {
  tagRelList?: ActivityItemTagRelRecord[];
  tagNames?: string;
}

interface Props {
  label: string;
  disabled: boolean;
  queryTagList: () => Promise<CmTagRecord[]>;
  getSelectedRows: () => ActivityItemRecord[];
  applyTagsToSelectedRows: (tags: CmTagRecord[]) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BindActivityItemTags',
  props: {
    label: null,
    disabled: { type: Boolean },
    queryTagList: null,
    getSelectedRows: null,
    applyTagsToSelectedRows: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  disabled: boolean;
  queryTagList: () => Promise<CmTagRecord[]>;
  getSelectedRows: () => ActivityItemRecord[];
  applyTagsToSelectedRows: (tags: CmTagRecord[]) => void;
}



const visible = ref(false);
const confirmLoading = ref(false);
const loading = ref(false);
const allTags = ref<CmTagRecord[]>([]);
const selectedTagIds = ref<string[]>([]);
const defaultSelectedTagIds = ref<string[]>([]);

const tagOptions = computed(() =>
  allTags.value.map((item) => ({
    label: item.name,
    value: item.id
  }))
);

const filterOption = (inputValue: string, option: { label?: string }) => {
  if (!inputValue) {
    return true;
  }
  return String(option?.label || '').includes(inputValue);
};

const getCommonTagNames = (rows: ActivityItemRecord[]) => {
  if (!rows.length) {
    return [] as string[];
  }
  const tagNameGroups = rows.map((row) => {
    if (row.tagRelList?.length) {
      return row.tagRelList.map((item) => item.tagName).filter(Boolean) as string[];
    }
    if (row.tagNames) {
      return row.tagNames
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  });
  return tagNameGroups.reduce<string[]>((acc, current, index) => {
    if (index === 0) {
      return [...current];
    }
    return acc.filter((item) => current.includes(item));
  }, []);
};

const closeModal = () => {
  visible.value = false;
};

const resetSelection = () => {
  selectedTagIds.value = [...defaultSelectedTagIds.value];
};

const openModal = async () => {
  visible.value = true;
  loading.value = true;
  try {
    const [tags, rows] = await Promise.all([props.queryTagList(), Promise.resolve(props.getSelectedRows())]);
    allTags.value = tags || [];
    const commonTagNames = getCommonTagNames(rows || []);
    defaultSelectedTagIds.value = allTags.value.filter((item) => commonTagNames.includes(item.name)).map((item) => item.id);
    selectedTagIds.value = [...defaultSelectedTagIds.value];
  } finally {
    loading.value = false;
  }
};

const submitSelection = async () => {
  confirmLoading.value = true;
  try {
    const selectedTags = allTags.value.filter((item) => selectedTagIds.value.includes(item.id));
    props.applyTagsToSelectedRows(selectedTags);
    closeModal();
  } finally {
    confirmLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(OioButton), {
      type: "primary",
      size: "small",
      disabled: __props.disabled,
      onClick: openModal
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(OioModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "绑定商品标签",
      width: 640,
      maskClosable: false,
      onCancel: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(OioButton), { onClick: closeModal }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_unref(OioButton), {
              type: "primary",
              loading: confirmLoading.value,
              onClick: submitSelection
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(OioSpin), { loading: loading.value }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: selectedTagIds.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedTagIds).value = $event)),
                mode: "multiple",
                class: "oio-select bind-activity-item-tags-dialog__select",
                "show-search": "",
                allowClear: true,
                options: _unref(tagOptions),
                placeholder: '请选择营销商品标签',
                "filter-option": filterOption,
                "max-tag-count": 3
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})